import { Notyf } from 'notyf';
import 'notyf/notyf.min.css';

const notyf = new Notyf({
  duration: 7000,
  types: [
    {
      type: 'error',
      backgroundColor: '#ef5350',
      duration: 10000, // autoclose after 10s
      dismissible: true,
      message: 'Whoops, something went wrong, please try again!',
    },
    {
      type: 'customSuccess',
      backgroundColor: '#0CADD3',
      icon: {
        className: 'notyf__icon--success',
        tagName: 'i',
      },
      className: 'notyf__toast--customSuccess',
    },
  ],
});

export const loginSuccess = () => {
  notyf.success('You have successfully authorized!');

  return true;
};

export const formDeleteSuccess = data => {
  notyf.success(`You have successfully deleted form of user ${data}!`);

  return true;
};

export const formArchivatingSuccess = data => {
  notyf.success(`You have successfully moved form of user ${data} to archive!`);

  return true;
};

export const saveAsDraftSuccess = () => {
  notyf.success(`You have successfully created draft form!`);

  return true;
};

export const createSuccess = () => {
  notyf.success(`You have successfully created new form!`);

  return true;
};

export const confirmSuccess = (text) => {
  notyf.success(text ? text : `You have successfully confirmed and saved dates!`);

  return true;
};

export const confirmSuccessUpdateFile = (msg) => {
  notyf.success(msg);

  return true;
};

export const emailSendSuccess = data => {
  notyf.success(
    `You have successfully sended email${data.length > 1 ? 's' : ''} to the ${
      data[0]
    }${data.length > 1 ? ` and ${data[1]}` : ''}!`,
  );
};

/**
 * Display detailed error 
 * Chose how many toast need to display by max = 5 || 1,2,3,4,5...
 * 
 * Use case
 * - display each error seprated toast
 * .catch(er => detailedError(er, { separate: true })); 
 * - display all errors in one toast
 * .catch(detailedError);
 * 
 * @param {*} er 
 * @param {*} param1 
 * @returns 
 */
export const detailedError = (er, { separate = false, max = 5, gap = 20 } = {}) => {
  const p = er?.response?.data ?? er ?? {};

  const toText = e =>
    (e?.code && e?.label)
      ? `${String(e.code).replace(/[._]/g, ' ').toLowerCase()}: ${e.label}`
      : (e?.message || 'Validation error');

  const list = Array.isArray(p?.errors) ? p.errors.map(toText).filter(Boolean) : [];
  const msgs = [...new Set(list.length ? list : [p?.message || 'Unexpected error'])];

  const capped = msgs.length > max
    ? [...msgs.slice(0, max), `…and ${msgs.length - max} more error${msgs.length - max > 1 ? 's' : ''}`]
    : msgs;

  if (separate) {
    capped.forEach((m, i) => setTimeout(() => notyf.error(m), i * gap));
  } else {
    notyf.error('• ' + capped.join('\n• '));
  }

  const firstErrorField = p?.first_error_field || p?.data?.first_error_field || null;
  return Promise.reject({ ...er, firstErrorField, messages: msgs });
};

export const error = data => {
  notyf.error(data.message);
};

export const fail = () => {
  notyf.error();
};

const style = document.createElement('style');
style.innerHTML = `
  .notyf__toast--customSuccess {
    color: white; /* Set text color to white */
  }
  .notyf__icon--success {
    color: white; /* Icon color */
    font-size: 17px; /* Icon size */
  }
`;
document.head.appendChild(style);


export const customSuccessNotification = (message) => {
  notyf.open({
    type: 'customSuccess',
    message: message,
  });

  return true;
};
